import React from "react";
import "./dadosIniciaisPF.scss";

//Componentes
import Breadcrumbs from "../../components/breadcrumbs";
import NavigationButtons from "../../components/navigationButtons";
import Field from "../../components/field";
import Dropdown from "../../components/dropdown";
import Form from "../../components/form";
import CheckObligation from "../../components/checkObligation";
import Typeaheader from "../../components/typeahead";
import FieldTelefone from "../../components/fieldTelefone";
import Utils from "../../helper/validateUtils";
import { Redirect } from "react-router-dom";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const eventPais = {
  value: "BRA",
};

class DadosIniciaisPF extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
      modalExisteCadastro: true
    };
  }

  componentDidUpdate(pervProps) {
    if (
      pervProps.dadosIniciaisPF.dadosIniciais_tipoDocumento !==
      this.props.dadosIniciaisPF.dadosIniciais_tipoDocumento
    ) {
      if (this.formFields.dadosIniciais_paisDocumento) {
        this.formFields.dadosIniciais_paisDocumento.validate(
          this.formFields.dadosIniciais_paisDocumento.input
        );
      }
    }
  }

  componentWillMount() {
    this.formFields = [];

    let {
      getListDadosIniciaisPFDocumentoAction,
      getListDadosIniciaisPFOrgaoEmissorAction,
      getListDadosIniciasPFPaisAction,
      handleChangeTypeaheadDadosIniciaisPais
    } = this.props;
    let { dadosIniciais_tipoDocumento } = this.props.dadosIniciaisPF;

    getListDadosIniciaisPFDocumentoAction();
    getListDadosIniciaisPFOrgaoEmissorAction();
    //getListDadosIniciasPFPaisAction();
    this.props.configuracaoDdi();

    if (dadosIniciais_tipoDocumento === "4") {
      handleChangeTypeaheadDadosIniciaisPais(eventPais);
    }
  }

  openModal = (flag) => {
    this.setState({modalExisteCadastro: flag});
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.dadosIniciaisPF.errorCodigoGerente != nextProps.dadosIniciaisPF.errorCodigoGerente) {
      var field = this.formFields['dadosIniciais_codigoGerente'];  
      field.validate(field.input, nextProps.dadosIniciaisPF.errorCodigoGerente); 
    }
    return true;
  }  

  render() {
    let {
      dadosIniciais_tipoDocumento,
      formPF,
      dropdownDocumentoList,
      dropdownOrgaoEmissorList,
      dadosIniciais_paisDocumento,
      typeaHeadDadosIniciaisPaisList,
      loadingDadosExisteCpf,
      loadingDadosPais,
      loadingDadosDocumento,
      loadingDadosOrgaoEmissor,
      dadosIniciais_codigoGerente,
      dadosIniciais_codigoGerenteViaLink,
      dadosIniciais_idDDDpais,
      errorCodigoGerente
    } = this.props.dadosIniciaisPF;

    const {ddiFixoBrasil, listPais, loadingDdi} = this.props.ddiReducer;

    let { tipoPessoaValue } = this.props.tipoCadastro;

    let {
      changeDadosIniciaisPFValueForm,
      getDadosIniciaisPFGerenteAction,
      resetDadosIniciaisPF_NomeGerenteAction,
      handleChangeDadosIniciaisPFDocumento,
      handleChangeDadosIniciaisPFOrgaoEmissor,
      handleChangeTypeaheadDadosIniciaisPais,
      setIdDDIPaisDadosIniciaisPF
    } = this.props;

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>
        <div className="col">
          <Form name="dadosIniciaisPF" noValidate={false}>
            <CheckObligation field="dadosIniciais_codigoGerente">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite o código do seu gerente"
                    required={validacoes.obrigatorio}
                    label="Código do seu gerente"
                    name="dadosIniciais_codigoGerente"
                    maxlength={6}
                    readOnly={dadosIniciais_codigoGerenteViaLink}
                    value={formPF.dadosIniciais_codigoGerente}
                    onChange={(field, value) => {
                      changeDadosIniciaisPFValueForm(field, value);
                      resetDadosIniciaisPF_NomeGerenteAction();
                      
                      if (this.dbcChange != null) {
                        clearInterval(this.dbcChange);
                      }

                      if (value.length > 1) {
                        this.dbcChange = setTimeout(
                          () => getDadosIniciaisPFGerenteAction(value),
                          600
                        );
                      }     
                    }}
                    returnObject={this.createRefFields}
                    otherValue={errorCodigoGerente}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation
              field="dadosIniciais_nomeGerente"
              fieldConditional={{
                dadosIniciais_codigoGerente: formPF.dadosIniciais_codigoGerente,
              }}
            >
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Nome do seu gerente"
                    required={validacoes.obrigatorio}
                    label="Nome do seu gerente"
                    name="dadosIniciais_nomeGerente"
                    maxlength={50}
                    value={formPF.dadosIniciais_nomeGerente}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                    loading={formPF.loadingDadosGerente}
                    readOnly
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_nomeCompleto">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite seu nome e sobrenome"
                    required={validacoes.obrigatorio}
                    label="Nome Completo"
                    name="dadosIniciais_nomeCompleto"
                    minlength={6}
                    maxlength={100}
                    value={formPF.dadosIniciais_nomeCompleto}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                    validateName={true}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_nomeSocial">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite seu nome social"
                    required={validacoes.obrigatorio}
                    label="Nome Social"
                    name="dadosIniciais_nomeSocial"
                    minlength={6}
                    maxlength={100}
                    value={formPF.dadosIniciais_nomeSocial}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_dataNascimento">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="date"
                    placeholder="12/06/1980"
                    required={validacoes.obrigatorio}
                    label="Data de Nascimento"
                    name="dadosIniciais_dataNascimento"
                    value={formPF.dadosIniciais_dataNascimento}
                    onChange={changeDadosIniciaisPFValueForm}
                    mask="99/99/9999"
                    validateSync={() =>
                      Utils.isDate(
                        "<=",
                        formPF.dadosIniciais_dataNascimento,
                        new Date().setFullYear(new Date().getFullYear() - 16),
                        "Idade menor que 16 anos"
                      )
                    }
                    returnObject={this.createRefFields}
                    keyup={() => this.verificaCadastro()}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_cpf">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="cpf"
                    placeholder="999.999.999-99"
                    required={validacoes.obrigatorio}
                    label="CPF"
                    name="dadosIniciais_cpf"
                    value={formPF.dadosIniciais_cpf}
                    mask="999.999.999-99"
                    validateSync={Utils.isCPF}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                    keyup={() => this.verificaCadastro()}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_tipoDocumento">
              {(validacoes) => (
                <div className="col-50 documento">
                  <Dropdown
                    value={dadosIniciais_tipoDocumento}
                    onChange={(event) => {
                      changeDadosIniciaisPFValueForm(
                        "dadosIniciais_numeroDocumento",
                        ""
                      );
                      handleChangeDadosIniciaisPFDocumento(event);
                      if (event.value === "4") {
                        handleChangeTypeaheadDadosIniciaisPais(eventPais);
                      }
                    }}
                    dataSource={dropdownDocumentoList}
                    required={validacoes.obrigatorio}
                    name="dadosIniciais_tipoDocumento"
                    label="Tipo de Documento com Foto"
                    returnObject={this.createRefFields}
                    loading={loadingDadosDocumento}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_numeroDocumento">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="text"
                    required={validacoes.obrigatorio}
                    label="Número do Documento com Foto"
                    name="dadosIniciais_numeroDocumento"
                    mask={
                      dadosIniciais_tipoDocumento === "5"
                        ? "SSSSSSSSSSSSSSSSSSSS"
                        : "99999999999999999999"
                    }
                    maxlength={20}
                    value={formPF.dadosIniciais_numeroDocumento}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            {/* <CheckObligation field="dadosIniciais_orgaoEmissor" fieldConditional={{ 'dadosIniciais_tipoDocumento': dadosIniciais_tipoDocumento }}>
              {(validacoes) =>
                <div className="col-50">
                  <Field
                    type="text"
                    placeholder="DETRAN, IFP"
                    maxlength={20}
                    required={validacoes.obrigatorio}
                    label="Orgão Emissor"
                    name="dadosIniciais_orgaoEmissor"
                    value={formPF.dadosIniciais_orgaoEmissor}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>}
            </CheckObligation> */}

            <CheckObligation
              field="dadosIniciais_orgaoEmissor"
              fieldConditional={{
                dadosIniciais_tipoDocumento: dadosIniciais_tipoDocumento,
              }}
            >
              {(validacoes) => (
                <div className="col-50 documento">
                  <Typeaheader
                    value={formPF.dadosIniciais_orgaoEmissor}
                    fieldValue="value"
                    fieldText="name"
                    onChange={handleChangeDadosIniciaisPFOrgaoEmissor}
                    dataSource={dropdownOrgaoEmissorList}
                    required={validacoes.obrigatorio}
                    name="dadosIniciais_orgaoEmissor"
                    label="Orgão Emissor"
                    returnObject={this.createRefFields}
                    loading={loadingDadosOrgaoEmissor}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_dataEmissao">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="date"
                    placeholder="12/06/1980"
                    required={validacoes.obrigatorio}
                    label="Data de Emissão"
                    name="dadosIniciais_dataEmissao"
                    value={formPF.dadosIniciais_dataEmissao}
                    onChange={changeDadosIniciaisPFValueForm}
                    mask="99/99/9999"
                    validateSync={() => {
                      let v1 = formPF.dadosIniciais_dataNascimento.split("/");
                      let dataNascimento = new Date(
                        v1[2] + "-" + v1[1] + "-" + v1[0]
                      );

                      if (
                        Utils.isDate(
                          "<=",
                          formPF.dadosIniciais_dataEmissao,
                          new Date(),
                          "Data de Emissão inválida."
                        ) !== true
                      ) {
                        return Utils.isDate(
                          "<=",
                          formPF.dadosIniciais_dataEmissao,
                          new Date(),
                          "Data de Emissão inválida."
                        );
                      }

                      return Utils.isDate(
                        ">=",
                        formPF.dadosIniciais_dataEmissao,
                        dataNascimento,
                        "Data de emissão não pode ser menor que a Data de Nascimento"
                      );
                    }}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_paisDocumento">
              {(validacoes) => (
                <div className="col-50">
                  <Typeaheader
                    dataSource={listPais}
                    fieldValue="IdPais"
                    fieldText="Nome"
                    onChange={handleChangeTypeaheadDadosIniciaisPais}
                    value={dadosIniciais_paisDocumento}
                    required={validacoes.obrigatorio}
                    name="dadosIniciais_paisDocumento"
                    loading={loadingDdi}
                    label="País do Documento"
                    returnObject={this.createRefFields}
                    disabled={
                      dadosIniciais_tipoDocumento === "4" ? true : false
                    }
                    validateSync={(pais) =>
                      Utils.validatePaisporDocumento(
                        pais,
                        dadosIniciais_tipoDocumento,
                        tipoPessoaValue,
                        "4",
                        "Brasil não é um país válido para o documento selecionado!",
                        "Somente o Brasil pode ser selecionado para o documento selecionado!"
                      )
                    }
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation
              field="dadosIniciais_dataVencimento"
              fieldConditional={{
                dadosIniciais_tipoDocumento: dadosIniciais_tipoDocumento,
              }}
            >
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="date"
                    placeholder="12/06/1980"
                    required={validacoes.obrigatorio}
                    label="Data de Vencimento"
                    name="dadosIniciais_dataVencimento"
                    value={formPF.dadosIniciais_dataVencimento}
                    onChange={changeDadosIniciaisPFValueForm}
                    mask="99/99/9999"
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            <div className="col-50">
              <CheckObligation field="dadosIniciais_ddiTelefoneCelular">
                {(validacoes) => (
                  <div className="col-20 p-0">
                    <FieldTelefone
                      type="ddi"
                      placeholder="+999"
                      required={validacoes.obrigatorio}
                      label="DDI"
                      name="dadosIniciais_ddiTelefoneCelular"
                      value={ddiFixoBrasil ? "+55" : formPF.dadosIniciais_ddiTelefoneCelular}
                      maxlength={5}
                      onChange={changeDadosIniciaisPFValueForm}
                      returnObject={this.createRefFields}
                      idDDIpais={dadosIniciais_idDDDpais}
                      onChangeDDI={setIdDDIPaisDadosIniciaisPF}
                      readOnly={ddiFixoBrasil}
                      selectToogle={!ddiFixoBrasil}
                      listPais={listPais.filter(x => x.DDI !== null)}
                    />
                  </div>
                )}
              </CheckObligation>

              <CheckObligation field="dadosIniciais_telefoneCelular">
                {(validacoes) => (
                  <div className="col-70 p-0">
                    <FieldTelefone
                      type="cel"
                      placeholder="(99)99999-9999"
                      required={validacoes.obrigatorio}
                      label="Telefone Celular (DDD + Número)"
                      name="dadosIniciais_telefoneCelular"
                      value={formPF.dadosIniciais_telefoneCelular}
                      maxlength={20 - formPF.dadosIniciais_ddiTelefoneCelular.replace("+", "").length}
                      onChange={changeDadosIniciaisPFValueForm}
                      returnObject={this.createRefFields}
                      ddiForMask={formPF.dadosIniciais_ddiTelefoneCelular}
                    />
                  </div>
                )}
              </CheckObligation>
            </div>           

            <CheckObligation field="dadosIniciais_email">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="email"
                    placeholder="Digite seu e-mail"
                    required={validacoes.obrigatorio}
                    maxlength={100}
                    label="E-mail"
                    name="dadosIniciais_email"
                    value={formPF.dadosIniciais_email}
                    onChange={changeDadosIniciaisPFValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>
          </Form>
        </div>

        <div className="col">
          <NavigationButtons
            history={this.props.history}
            openModalSemGerente={!formPF.dadosIniciais_codigoGerente}
            openModalExisteCadastro={this.props.dadosIniciaisPF.dadosIniciais_cpfExiste} 
            validateFields={this.validateFields}
            disabledProx={loadingDadosExisteCpf}
          />
          {/* {this.props.dadosIniciaisPF.dadosIniciais_cpfExiste && (
            <Redirect to="/conclusao" />          
          )} */}
        </div>
      </section>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self;
  };

  verificaCadastro = () => {
    
    if (
      this.props.dadosIniciaisPF.formPF.dadosIniciais_dataNascimento.length === 10 &&
      this.props.dadosIniciaisPF.formPF.dadosIniciais_cpf.length === 14
    ) {
      this.props.getDadosIniciaisExisteCpfAction(
        this.props.dadosIniciaisPF.formPF.dadosIniciais_dataNascimento,
        this.props.dadosIniciaisPF.formPF.dadosIniciais_cpf
      );
    }
  }

  validateFields = async () => {
    let list = [];

    // if (
    //   this.props.dadosIniciaisPF.formPF.dadosIniciais_dataNascimento &&
    //   this.props.dadosIniciaisPF.formPF.dadosIniciais_cpf
    // ) {
    //   await this.props.getDadosIniciaisExisteCpfAction(
    //     this.props.dadosIniciaisPF.formPF.dadosIniciais_dataNascimento,
    //     this.props.dadosIniciaisPF.formPF.dadosIniciais_cpf
    //   );
    // }

    return new Promise((resolve) => {
      for (let key in this.formFields) {
        this.formFields[key].validate(this.formFields[key].input).then((r) => {
          list.push({ name: this.formFields[key].props.name, valid: r });
          if (Object.keys(this.formFields).length === list.length)
            resolve(list);
        });
      }
    });
  };
}

export default DadosIniciaisPF;
